import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KW_LOGO = "https://customer-assets.emergentagent.com/job_loyalty-onboard-kw/artifacts/7t06knss_WhatsApp%20Image%202026-04-01%20at%2014.43.05.jpeg";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      const data = res.data;
      toast.success(`Welcome, ${data.user.name}!`);
      onLogin(data.user, data.token);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <div className="flex items-center justify-center gap-4 mb-6">
              <img src={KW_LOGO} alt="KW Blue Pearl" className="h-16 w-auto" />
            </div>
            <p className="text-sm text-[#64748B]">Loyalty Program Management Platform</p>
          </div>
          <Card className="border border-[#E2E8F0] shadow-sm">
            <CardHeader className="pb-4">
              <CardTitle className="font-heading text-xl">Sign In</CardTitle>
              <CardDescription>Enter your credentials to access the dashboard</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="space-y-2">
                  <Label htmlFor="username" className="text-xs uppercase tracking-[0.2em] text-[#64748B]">Username</Label>
                  <Input id="username" type="text" placeholder="Enter your username" value={username} onChange={(e) => setUsername(e.target.value)} className="h-11" data-testid="login-username-input" required />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password" className="text-xs uppercase tracking-[0.2em] text-[#64748B]">Password</Label>
                  <div className="relative">
                    <Input id="password" type={showPassword ? "text" : "password"} placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 pr-10" data-testid="login-password-input" required />
                    <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#64748B] hover:text-[#0A0A0A] transition-colors">
                      {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>
                <Button type="submit" className="w-full h-11 bg-[#002FA7] hover:bg-[#001F6E] text-white font-medium" disabled={isLoading} data-testid="login-submit-btn">
                  {isLoading ? <span className="flex items-center gap-2"><span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>Signing in...</span> : "Sign In"}
                </Button>
              </form>
            </CardContent>
          </Card>
          <p className="text-center text-xs text-[#94A3B8]">KW Blue Pearl - The Rare Gem of Karol Bagh, Delhi</p>
        </div>
      </div>
      <div className="hidden lg:block lg:w-1/2 relative">
        <div className="absolute inset-0 login-bg" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 47, 167, 0.4)), url('https://images.pexels.com/photos/33964179/pexels-photo-33964179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white p-8">
            <img src={KW_LOGO} alt="KW Blue Pearl" className="h-24 w-auto mx-auto mb-4 rounded-lg bg-white/90 p-2" />
            <p className="text-lg opacity-90">Premium Loyalty Experience</p>
          </div>
        </div>
      </div>
    </div>
  );
}
